import React, { Component } from 'react'
import QRCode from 'qrcode'
import Loader from './Loader'

class DesktopLanding extends Component {
	constructor(props) {
		super(props)
		this.state = {
			qr: null
		}
		this.qr_url = null
	}

	componentDidMount() {
		this._makeQR()
	}

	componentDidUpdate() {
		this._makeQR()
	}

	_getAppUrl = () => {
		if (this.props.app_url)
			return this.props.app_url
		if (this.props.app_name !== null)
			return window.location.origin
		return null
	}

	_makeQR = () => {
		const url = this._getAppUrl()
		if (url === null || url === this.qr_url)
			return ;
		this.qr_url = url
		QRCode.toDataURL(url, {
			errorCorrectionLevel: 'H',
			margin: 1,
			width: 480,
			color: {
				dark: '#1F2937',
				light: '#FFFFFF'
			}
		})
		.then(qr => {
			this.setState({ qr: qr })
		})
		.catch(err => console.log(err))
	}

	_getLang = () => {
		const browser = (navigator.language) ? navigator.language.substring(0, 2).toLowerCase() : ""
		if (this.props.lang_assets[browser])
			return browser
		if (this.props.lang_default !== null && this.props.lang_assets[this.props.lang_default])
			return this.props.lang_default
		return "fr"
	}

	//mélange la couleur du thème avec du blanc pour le fond teinté
	_tint = (hex, factor) => {
		const r = Math.round(parseInt(hex.substring(0, 2), 16) * (1 - factor) + 255 * factor)
		const g = Math.round(parseInt(hex.substring(2, 4), 16) * (1 - factor) + 255 * factor)
		const b = Math.round(parseInt(hex.substring(4, 6), 16) * (1 - factor) + 255 * factor)
		return 'rgb(' + r + ', ' + g + ', ' + b + ')'
	}

	//met en gras les segments entre astérisques ("Ouvrez *l'appareil photo*")
	_bold = (text) => {
		const parts = text.split('*')
		return parts.map((part, i) => {
			if (i % 2 === 1)
				return (<b className="font-semibold text-gray-900" key={i}>{part}</b>)
			return part
		})
	}

	render() {
		if (this.props.app_name === null || this.props.theme === null)
		{
			return (
				<div className="App">
					<div className="loading">
						<Loader />
					</div>
				</div>
			)
		}
		const lang_assets = this.props.lang_assets[this._getLang()].desktop
		const color1 = '#' + this.props.theme.color1
		let url_name = this._getAppUrl().replace(/^https?:\/\//, '')
		url_name = url_name.replace(/\/$/, '')
		let brandLogoJSX = null
		if (this.props.logo)
		{
			brandLogoJSX = (
				<span className="h-9 w-9 rounded-full bg-white shadow-sm overflow-hidden flex-shrink-0">
					<img className="h-full w-full object-cover" src={this.props.logo} alt="" />
				</span>
			)
		}
		let qrJSX = null
		if (this.state.qr !== null)
		{
			let qrLogoJSX = null
			if (this.props.logo)
			{
				qrLogoJSX = (
					<span className="absolute top-1/2 left-1/2 h-11 w-11 rounded-full bg-white border-2 border-white shadow overflow-hidden" style={{ transform: 'translate(-50%, -50%)' }}>
						<img className="h-full w-full object-cover" src={this.props.logo} alt="" />
					</span>
				)
			}
			qrJSX = (
				<span className="relative block">
					<img className="w-48 h-48 block" src={this.state.qr} alt={lang_assets.qr_alt} />
					{qrLogoJSX}
				</span>
			)
		}
		else
			qrJSX = (<span className="block w-48 h-48 bg-gray-100 rounded-lg animate-pulse"></span>)
		const steps = [lang_assets.step1, lang_assets.step2, lang_assets.step3]
		const stepsJSX = steps.map((step, i) => {
			let connectorJSX = null
			if (i < steps.length - 1)
				connectorJSX = (<span className="flex-1 w-px bg-gray-200 my-1"></span>)
			return (
				<li className="flex gap-3 items-stretch" key={i}>
					<span className="flex flex-col items-center flex-shrink-0">
						<span className="flex items-center justify-center h-6 w-6 rounded-full border border-gray-400 text-xs font-semibold text-gray-700">{i + 1}</span>
						{connectorJSX}
					</span>
					<span className="text-sm text-gray-600 pb-5 pt-1">{this._bold(step)}</span>
				</li>
			)
		})
		return (
			<div className="min-h-screen w-screen px-10 py-8" style={{ backgroundColor: this._tint(this.props.theme.color1, 0.92) }}>
				<div className="flex items-center gap-3 pb-12">
					{brandLogoJSX}
					<span className="text-base font-bold text-gray-900">{this.props.app_name}</span>
				</div>
				<div className="max-w-3xl mx-auto bg-white border border-gray-200 rounded-3xl px-10 py-10 flex flex-wrap items-center justify-between gap-10">
					<div style={{ maxWidth: '24rem' }}>
						<h1 className="text-2xl font-bold text-gray-900 pb-6">{lang_assets.title}</h1>
						<ol className="list-none p-0 m-0">
							{stepsJSX}
						</ol>
					</div>
					<div className="flex-shrink-0 mx-auto">
						{qrJSX}
					</div>
				</div>
				<p className="text-center text-sm text-gray-600 pt-6">
					{lang_assets.or_prefix}{' '}
					<span className="inline-block font-mono text-sm text-gray-700 bg-white border border-gray-200 rounded-md px-2 py-1">{url_name}</span>
					{' '}{lang_assets.or_suffix}
				</p>
			</div>
		)
	}
}

export default DesktopLanding
